import type { BlInputMaskProps } from "Shared/Inputs/BlInput";

const alphanumericBlock = { mask: /^[A-Za-z0-9]$/ };

/**
 * IBAN mask: 2 letters (country) + 2 digits (check) + up to 30 alphanumeric chars.
 * Groups displayed in blocks of 4. Max 34 chars (E.164 IBAN standard).
 * `unmask: true` (BlInput default) strips spaces when saving to form state.
 */
export const ibanMaskProps: BlInputMaskProps = {
  mask: "aa00[ HHHH][ HHHH][ HHHH][ HHHH][ HHHH][ HHHH][ HHHH][ HH]",
  blocks: {
    H: alphanumericBlock,
  },
  uppercase: true,
};

/**
 * SWIFT/BIC mask: 6 letters + 2 alphanumeric + optionally 3 alphanumeric.
 * Valid length: 8 or 11 characters.
 */
export const swiftMaskProps: BlInputMaskProps = {
  mask: "aaaaaaHH[HHH]",
  blocks: {
    H: alphanumericBlock,
  },
  uppercase: true,
};
